var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f861199a-9921-482a-87ea-8504385ff0cd",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "f13c7428-fd1f-409a-aa83-518164fbbc0c",
    x1: 9,
    y1: 7.11,
    x2: 9,
    y2: 14.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a67af4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#552f99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a6b01360-3b65-4cb5-8c1b-eed2f64af70c",
    x1: 8.8,
    y1: 3.31,
    x2: 9.32,
    y2: 9.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a67af4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#552f99"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-identity-235") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.15,11.75a7.34,7.34,0,0,1,1-7.2,1.94,1.94,0,0,1-.7-.83,8.48,8.48,0,0,0-1.17,8.6A3.1,3.1,0,0,1,2.15,11.75ZM5.94,1.14a3.14,3.14,0,0,1,.62.9A7.5,7.5,0,0,1,9,1.61,7.33,7.33,0,0,1,13.33,3a2.15,2.15,0,0,1,.55-.69h0L14,2.22A8.44,8.44,0,0,0,5.94,1.14Zm9.91,5.12a7.32,7.32,0,0,1-1,7.19,2,2,0,0,1,.43.4,1.94,1.94,0,0,1,.27.43,8.48,8.48,0,0,0,1.17-8.6A3.13,3.13,0,0,1,15.85,6.26ZM11.44,16A7.25,7.25,0,0,1,9,16.39H9A7.32,7.32,0,0,1,4.67,15a2.05,2.05,0,0,1-.55.69h0L4,15.78a8.48,8.48,0,0,0,8.09,1.09A3.13,3.13,0,0,1,11.44,16Z",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.18,1.87a2.09,2.09,0,1,1-3,0,2.09,2.09,0,0,1,3,0Z",
    fill: "#32bedd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.42,4.07a1,1,0,0,0,0-1.45A1,1,0,0,0,3,2.62,1,1,0,0,0,3,4.07H3a1,1,0,0,0,1.44,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.18,1.87a2.09,2.09,0,1,1,0,3,2.09,2.09,0,0,1,0-2.95Z",
    fill: "#32bedd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.38,2.62a1,1,0,1,0,0,1.45h0a1,1,0,0,0,0-1.45",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.82,16.13a2.09,2.09,0,1,1,3,0,2.09,2.09,0,0,1-3,0Z",
    fill: "#32bedd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.58,13.93a1,1,0,0,0,0,1.45,1,1,0,0,0,1.44,0,1,1,0,0,0,0-1.45h0a1,1,0,0,0-1.44,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82,16.13a2.09,2.09,0,1,1,0-2.95,2.09,2.09,0,0,1,0,2.95Z",
    fill: "#32bedd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.62,15.38a1,1,0,1,0,0-1.45h0a1,1,0,0,0,0,1.45",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.51,12.92a.76.76,0,0,0,.76-.76v-.09C13,9.69,11.61,7.74,9,7.74S5,9.39,4.74,12.08a.76.76,0,0,0,.68.84h7.09Z",
    fill: "url(#f13c7428-fd1f-409a-aa83-518164fbbc0c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,8.31a2.41,2.41,0,0,1-1.3-.38L9,11.28,10.27,8A2.37,2.37,0,0,1,9,8.31Z",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.01,
    cy: 5.92,
    r: 2.39,
    fill: "url(#a6b01360-3b65-4cb5-8c1b-eed2f64af70c)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElm);
export default __webpack_public_path__ + "static/media/ELM.325b84efc437800e23e009240b91a770.svg";
export { ForwardRef as ReactComponent };